import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessMessage } from './process-message';
export { ProcessMessage };
import { processMessageSchema } from '@schemas/business-objects/process-message';
import { ProcessMessagePropertyFormArray } from './process-message-property-form-group';

export class ProcessMessageFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    displayName: SchemaFormControl;
    description: SchemaFormControl;
    properties: ProcessMessagePropertyFormArray;
  };

  declare value: Partial<ProcessMessage>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(processMessageSchema, ProcessMessage, data, options);
  }

  get object(): ProcessMessage {
    return new ProcessMessage(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'properties':
        return new ProcessMessagePropertyFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ProcessMessage[]> {
    return ProcessMessage.find(filter);
  }

  static async findOne(filter?: any): Promise<ProcessMessage | null> {
    return ProcessMessage.findOne(filter);
  }

  static async findById(id: string, filter?: any): Promise<ProcessMessage> {
    return ProcessMessage.findById(id, filter);
  }

  static async create(data: Partial<ProcessMessage>): Promise<ProcessMessage> {
    return ProcessMessage.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ProcessMessage>,
  ): Promise<ProcessMessage> {
    return ProcessMessage.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ProcessMessage.deleteById(id);
  }
}

export class ProcessMessageFormArray extends PersistedFormArray {
  declare controls: ProcessMessageFormGroup[];

  readonly entityName = 'ProcessMessage' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(processMessageSchema, ProcessMessage, options);
  }

  protected override createItemGroup() {
    return new ProcessMessageFormGroup();
  }

  get array(): ProcessMessage[] {
    return this.controls.map((group: ProcessMessageFormGroup) => group.object);
  }
}

export class ProcessMessagePersistedArray extends PersistedArray<ProcessMessage> {
  readonly entityName = 'ProcessMessage' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessMessage, options);
  }
}
